import axios from 'axios';
import {serverAddress,getRequest} from "./axios"
import {getMenuList} from './index';
import {getStore, getStoreTemp, setStore, setStoreTemp} from './storage.js';
import router from '@/router/index';
// import Cookies from "js-cookie";

let util = {};

util.title = function (title) {
  if(serverAddress.indexOf('keprint') > -1){
    title = title || '可印后台管理系统';
  } else {
    title = title || '惠众利达后台管理系统';
  }
  window.document.title = title;
};

util.inOf = function (arr, targetArr) {
  let res = true;
  arr.forEach(item => {
    if (targetArr.indexOf(item) < 0) {
      res = false;
    }
  });
  return res;
};

util.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true;
  } else {
    return false;
  }
};



// 格式化日期
export function formatDate(date, fmt) {
  var o = {
    "M+": date.getMonth() + 1,                 //月份
    "d+": date.getDate(),                    //日
    "h+": date.getHours(),                   //小时
    "m+": date.getMinutes(),                 //分
    "s+": date.getSeconds(),                 //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

// 获取当天的零点时间和末点时间
export function getTodayTime()   {
  return {
    beginDate: new Date(new Date(new Date().toLocaleDateString()).getTime()),
    endData: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
  }
}

export function getUserInfo() {
  let userInfo = getStore("userInfo") ? JSON.parse(getStore("userInfo")) : null;
  if (userInfo === null) {
    userInfo = getStoreTemp("userInfo") ? JSON.parse(getStoreTemp("userInfo")) : null;
  }
  return userInfo
}


export function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURI(r[2])
  return null
}

util.getUserInfo = getUserInfo;
util.getQueryString = getQueryString;


export default util;



// WEBPACK FOOTER //
// ./src/api/util.js